var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOncallHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M17.314,8.2896L18.2753,7.8899C18.1391,7.5629 17.9848,7.2435 17.813,6.9336L16.9026,7.4387C17.0556,7.7144 17.193,7.9987 17.314,8.2896L17.314,8.2896Z",
    id: "path_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M11.1064,2.1719L10.9316,3.1979V3.1981C11.2429,3.2511 11.5509,3.3217 11.8543,3.4093L12.1432,2.4091C11.8023,2.3108 11.4563,2.2315 11.1064,2.1719L11.1064,2.1719Z",
    id: "path_1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M15.8328,4.4542C15.5686,4.2179 15.2916,3.9966 15.0028,3.791L14.3992,4.6393C14.6565,4.8224 14.9034,5.0197 15.1387,5.2301L15.8328,4.4542Z",
    id: "path_2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M14.1038,3.2243C13.7935,3.0523 13.4741,2.898 13.1467,2.7617L12.747,3.7229L12.7468,3.7227C13.0385,3.8441 13.3233,3.9816 13.5998,4.1348L14.1038,3.2243Z",
    id: "path_3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M17.8389,10.1038L18.8653,9.9287H18.8651C18.8056,9.5792 18.7264,9.2332 18.6281,8.8926L17.6279,9.182H17.6277C17.7152,9.4851 17.7857,9.7928 17.8389,10.1038L17.8389,10.1038Z",
    id: "path_4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M16.3983,6.6395L17.2466,6.0358H17.2468C17.0412,5.7473 16.8199,5.4702 16.5838,5.206L15.8076,5.899H15.8078C16.0183,6.1347 16.2153,6.3818 16.3982,6.6395H16.3983Z",
    id: "path_5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M18.9849,10.9861L17.9454,11.0456C17.9547,11.2079 17.9594,11.3728 17.9594,11.5365H17.9592C17.9592,13.2095 17.463,14.845 16.5335,16.2361C15.6041,17.6273 14.2828,18.7115 12.7372,19.3516C11.1913,19.9919 9.4904,20.1594 7.8494,19.8329C6.2084,19.5065 4.7012,18.7007 3.518,17.5176C2.3351,16.3345 1.5296,14.8272 1.2033,13.1863C0.877,11.5453 1.0445,9.8444 1.6849,8.2985C2.3252,6.7528 3.4096,5.4318 4.8008,4.5024C6.1919,3.5731 7.8276,3.077 9.5006,3.0772C9.664,3.0772 9.8293,3.0821 9.9912,3.0914L10.0509,2.0519C9.8689,2.0415 9.6836,2.0361 9.5007,2.0361C7.6217,2.0359 5.7849,2.5931 4.2226,3.637C2.6602,4.6807 1.4425,6.1644 0.7232,7.9003C0.0042,9.6363 -0.184,11.5463 0.1824,13.3892C0.5491,15.2321 1.4537,16.9248 2.7824,18.2536C4.1109,19.5823 5.8038,20.4872 7.6464,20.8538C9.4893,21.2204 11.3995,21.0323 13.1353,20.3134C14.8713,19.5943 16.355,18.3766 17.3989,16.8143C18.4428,15.252 19,13.4152 19,11.5363C19,11.3528 18.9946,11.1678 18.9844,10.9858L18.9849,10.9861Z",
    id: "path_6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M6.9758,1.0413H11.9731C12.256,1.0348 12.4821,0.8037 12.4821,0.5206C12.4821,0.2376 12.256,0.0063 11.9731,0H6.9758C6.6929,0.0063 6.4668,0.2376 6.4668,0.5206C6.4668,0.8037 6.6929,1.0348 6.9758,1.0413Z",
    id: "path_7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M9.4743,5.836C9.1868,5.836 8.9537,6.0692 8.9537,6.3566V10.6513C8.6839,10.8188 8.5056,11.1005 8.4694,11.4159C8.4333,11.7312 8.5432,12.046 8.7682,12.2702C8.9929,12.4944 9.3078,12.6037 9.6231,12.5667C9.9386,12.5297 10.2197,12.3505 10.3865,12.0803H14.7345C15.022,12.0803 15.2551,11.8472 15.2551,11.5598C15.2551,11.2723 15.022,11.0392 14.7345,11.0392H10.417C10.3203,10.8617 10.174,10.7159 9.996,10.6198V6.3554C9.9957,6.2172 9.9406,6.0851 9.8427,5.9876C9.7449,5.8902 9.6123,5.8356 9.4742,5.8359L9.4743,5.836Z",
    id: "path_8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOncallHome);
export default __webpack_public_path__ + "static/media/ic_oncall_home.1449bec37a1610ee511c3dd9ca35695c.svg";
export { ForwardRef as ReactComponent };